import React, { useState, useEffect } from "react";
import { IModalProps, Modal } from "../../../seenspire-library";
import {
  Container,
  ModalSubtitle,
  ModalTitle,
  StyledCtaButton,
  StyledSelect,
  ModalCustomStyles,
  ErrorMessage,
} from "./styles";
import { api } from "../../backend/api";
import { getToken } from "../../backend/session";
import { Stream } from "seenspire-api-client";

interface StreamSelectionModalProps extends IModalProps {
  onSubmit: (streamCode: string, streamName: string) => void;
  title: string;
  description: string;
}

const StreamSelectionModal = (props: StreamSelectionModalProps) => {
  const { onSubmit, title, description } = props;
  const [selectedStream, setSelectedStream] = useState<Stream | null>(null);
  const [streams, setStreams] = useState<Stream[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStreams = async () => {
      setIsLoading(true);
      setError(null);
      
      const currentToken = getToken();
      const headers = {
        Authorization: `Bearer ${currentToken.access_token}`
      };

      try {
        const response = await api.get(
          `${process.env.REACT_APP_API}/api/streams?s=id&o=DESC`,
          { headers }
        );
        setStreams(response.data.data);
      } catch (error) {
        console.error(error);
        setError('Failed to load streams. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchStreams();
  }, []);

  return (
    <Modal
      customStyle={{ content: { minHeight: 0, ...ModalCustomStyles.content } }}
      {...props}
    >
      <Container>
        <ModalTitle>{title}</ModalTitle>
        <ModalSubtitle color="gray">{description}</ModalSubtitle>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <StyledSelect
          value={{
            label: selectedStream?.name ?? '',
            value: selectedStream?.id != null ? String(selectedStream.id) : undefined
          } as any}
          onChange={(stream: any) => setSelectedStream(streams ? streams.find(s => String(s.id) === stream.value) ?? null : null)}
          title="Select Your Stream"
          options={streams.map(stream => ({
            label: stream.name,
            value: String(stream.id)
          }))}
          isLoading={isLoading}
        />
        <StyledCtaButton
          onClick={() => selectedStream ? onSubmit(selectedStream.code, selectedStream?.name) : undefined}
          buttonType="cta"
          disabled={!selectedStream || isLoading}
        >
          Assign Stream
        </StyledCtaButton>
      </Container>
    </Modal>
  );
};

export default StreamSelectionModal;
